import React, { useMemo } from "react"
import useViewport from "../../../../hooks/useViewport"
import { className as cn } from "../../../../helpers/className"
import { sanitizeHtml } from "@/helpers/htmlUtils"
export const TextRow = ({
  label,
  value,
  className,
  labelClassName = "text-black-50",
  valueClassName,
  isHtml = false,
}) => {
  const { isMobileViewport } = useViewport()
  const classNames = useMemo(
    () => ({
      wrapper: cn("d-flex align-items-start", className, isMobileViewport ? "flex-column" : "gap-1"),
      label: cn(labelClassName, !isMobileViewport && "w-25"),
      value: cn(valueClassName, !isMobileViewport && "w-75"),
    }),
    [className, isMobileViewport, labelClassName, valueClassName]
  )

  const renderValue = () => {
    if (!value) return "—"

    return isHtml ? <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }} /> : value
  }

  return (
    <div className={classNames.wrapper}>
      <div className={classNames.label}>{label}</div>
      <div className={classNames.value}>{renderValue()}</div>
    </div>
  )
}

export default TextRow
